export default function initSearch() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchModal = document.getElementById('search-modal');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = searchModal?.querySelector('.search-modal__input');
  const body = document.body;
  const navToggle = document.querySelector('.nav__toggle');
  const navOverlay = document.querySelector('.nav__overlay');

  if (!searchToggle || !searchModal) {
    return; // Search elements not found on this page
  }

  const closeModal = () => {
    searchModal.setAttribute('aria-hidden', 'true');
    body.classList.remove('no-scroll');
    searchToggle.focus(); // Return focus to toggle button
  };

  const openModal = () => {
    searchModal.setAttribute('aria-hidden', 'false');
    body.classList.add('no-scroll');

    // Close navigation menu if open
    if (navToggle && navOverlay) {
      navToggle.setAttribute('aria-expanded', 'false');
      navOverlay.setAttribute('aria-hidden', 'true');
    }

    // Focus the search input when modal opens
    setTimeout(() => {
      searchInput?.focus();
    }, 100);
  };

  const handleEscapeKey = (event) => {
    if (event.key === 'Escape' && searchModal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  };

  const handleClickOutside = (event) => {
    if (searchModal.getAttribute('aria-hidden') === 'false') {
      const modalContent = searchModal.querySelector('.search-modal__content');
      if (!modalContent.contains(event.target)) {
        closeModal();
      }
    }
  };

  // Event listeners
  searchToggle.addEventListener('click', openModal);

  if (searchClose) {
    searchClose.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', handleEscapeKey);
  searchModal.addEventListener('click', handleClickOutside);
}
